import merge from 'deepmerge';

import type { Translations } from '../types';
import common from './common';
import de from './de/mobile-pro.json';
import deAT from './de-AT/mobile-pro.json';
import deCH from './de-CH/mobile-pro.json';
import en from './en/mobile-pro.json';
import fr from './fr/mobile-pro.json';
import frCH from './fr-CH/mobile-pro.json';
import pro from './pro';

const mobilePro = {
  fr: fr.mobile_pro,
  en: en.mobile_pro,
  de: de.mobile_pro,
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'fr-CH': merge(fr.mobile_pro, frCH.mobile_pro || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.mobile_pro, deCH.mobile_pro || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.mobile_pro, deAT.mobile_pro || {}),
};

export default merge.all<Translations>([common, pro, mobilePro]);
